import { createServerFn } from "@tanstack/react-start";

type Story = {
  id: string;
  publish_date: string;
  publish_at: string;
  question: string;
  story: string;
  solution: string;
  category: string;
  legislation_refs: string[];
};

const COLUMNS =
  "id,publish_date,publish_at,question,story,solution,category,legislation_refs";

export const getTodayLegalStory = createServerFn({ method: "GET" }).handler(
  async () => {
    const { supabaseAdmin } = await import(
      "@/integrations/supabase/client.server"
    );
    const nowIso = new Date().toISOString();
    const { data, error } = await (supabaseAdmin as any)
      .from("daily_legal_stories")
      .select(COLUMNS)
      .lte("publish_at", nowIso)
      .order("publish_at", { ascending: false })
      .limit(1)
      .maybeSingle();
    if (error) {
      console.error("[getTodayLegalStory]", error);
      return { story: null as Story | null };
    }
    return { story: (data as Story | null) ?? null };
  },
);

export const listLegalStories = createServerFn({ method: "GET" }).handler(
  async () => {
    const { supabaseAdmin } = await import(
      "@/integrations/supabase/client.server"
    );
    const nowIso = new Date().toISOString();
    const { data, error } = await (supabaseAdmin as any)
      .from("daily_legal_stories")
      .select(COLUMNS)
      .lte("publish_at", nowIso)
      .order("publish_at", { ascending: false })
      .limit(120);
    if (error) {
      console.error("[listLegalStories]", error);
      return { stories: [] as Story[] };
    }
    return { stories: (data as Story[]) ?? [] };
  },
);
